import { css } from '@emotion/css';
import React, { useEffect } from 'react';

import Notification, { Type } from 'components/Notification';
import { useRemindersContext } from './context';

const wrapper = css({
  position: 'absolute',
  right: '0.625rem',
  zIndex: 5,
  top: '110px',
  '@media (max-width: 1288px)': {
    top: '90px',
  },
  '@media (max-width: 768px)': {
    margin: '1.25rem !important',
    right: '0px',
    left: '0px',
    marginTop: '0 !important',
  },
});

export interface NotificationProps {
  type?: Type;
  title: string;
}

const GiftReminderNotification = () => {
  const { notification, setNotification } = useRemindersContext();
  useEffect(() => {
    let timer;
    if (notification) {
      timer = setTimeout(() => {
        setNotification(null);
      }, 3000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [notification]);

  if (notification) {
    return (
      <div className={wrapper}>
        <Notification type={notification.type} title={notification.title} />
      </div>
    );
  }
  return null;
};

export default GiftReminderNotification;
